/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type profileSecurity_viewer = {
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"SettingsProfileSubNav_viewer">;
    readonly " $refType": "profileSecurity_viewer";
};
export type profileSecurity_viewer$data = profileSecurity_viewer;
export type profileSecurity_viewer$key = {
    readonly " $data"?: profileSecurity_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"profileSecurity_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "profileSecurity_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SettingsProfileSubNav_viewer"
    }
  ],
  "type": "Viewer"
};
(node as any).hash = '1363c06b358bafb6a704bb6771734df4';
export default node;
